module.exports = __webpack_public_path__ + "static/img/acq-3.22e40f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acq-3.png
// module id = s8xH
// module chunks = 1